/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect } from 'react';
import { MdDone } from 'react-icons/md';
import { toast } from 'react-toastify';
import Loading from '@components/Loading';
import SelectInput from '@components/SelectInput';
import NotAuthenticated from '@components/NotAuthenticated';
import data, { ConfigStore } from '@store/SettingsStore';
import { observer } from 'mobx-react-lite';
import ApiService from '@services/api';
import { useParams } from 'react-router-dom';
import { useSession } from '@hooks/useSession';
import SwitchButton from '@components/SwitchButton';
import Button from '@components/Button';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Certificate from './Certificate';

import {
  Container,
  Title,
  Form,
  Box,
  Field,
  ApplyButton,
  HeaderBox,
  SectionTitle,
  Row,
  TagList,
  QuillWrapper,
  Input,
} from './styles';

const ambienteOptions = [
  { label: 'Produção', value: 1 },
  { label: 'Homologação', value: 2 },
];

interface EmailTemplateConfigProps {
  title: string;
  store: any;
}

const defaultTemplates: { [key: string]: { subject: string; body: string } } = {
  'NF-e': {
    subject: 'Nota Fiscal Eletrônica',
    body: `<p>Olá <strong>{{destinatario_nome}}</strong>,</p>
            <p>Segue em anexo a sua Nota Fiscal Eletrônica.</p>
            <p><u>Detalhes da NF-e:</u></p>
            <ul>
            <li>Número: <strong>:{{numero}}</strong></li>
            <li>Série: <strong>{{serie}}</strong></li>
            <li>Valor: <strong>{{valor}}</strong></li>
            <li>Chave de Acesso: <strong>{{chave}}</strong></li>
            </ul>
            <p>Qualquer dúvida estamos à disposição.</p>
            <p>Atenciosamente,</p>
            <p><strong>{{emitente_nome}}</strong></p>`,
  },
  'NFC-e': {
    subject: 'Nota Fiscal de Consumidor Eletrônica',
    body: `<p>Olá <strong>{{destinatario_nome}}</strong>,</p>
            <p>Segue em anexo a sua Nota Fiscal de Consumidor Eletrônica.</p>
            <p><u>Detalhes da NFC-e:</u></p>
            <ul>
            <li>Número: <strong>:{{numero}}</strong></li>
            <li>Série: <strong>{{serie}}</strong></li>
            <li>Valor: <strong>{{valor}}</strong></li>
            <li>Chave de Acesso: <strong>{{chave}}</strong></li>
            </ul>
            <p>Qualquer dúvida estamos à disposição.</p>
            <p>Atenciosamente,</p>
            <p><strong>{{emitente_nome}}</strong></p>`,
  },
  'NFS-e': {
    subject: 'Nota Fiscal de Serviço Eletrônica',
    body: `<p>Olá <strong>{{destinatario_nome}}</strong>,</p>
            <p>Segue em anexo a sua Nota Fiscal de Serviço Eletrônica.</p>
            <p><u>Detalhes da NFS-e:</u></p>
            <ul>
            <li>Número: <strong>:{{numero}}</strong></li>
            <li>Série: <strong>{{serie}}</strong></li>
            <li>Valor: <strong>{{valor}}</strong></li>
            <li>Chave de Acesso: <strong>{{chave}}</strong></li>
            </ul>
            <p>Qualquer dúvida estamos à disposição.</p>
            <p>Atenciosamente,</p>
            <p><strong>{{emitente_nome}}</strong></p>`,
  },
  'CT-e': {
    subject: 'Conhecimento de Transporte Eletrônico',
    body: `<p>Olá <strong>{{destinatario_nome}}</strong>,</p>
            <p>Segue em anexo o seu Conhecimento de Transporte Eletrônico.</p>
            <p><u>Detalhes do CT-e:</u></p>
            <ul>
            <li>Número: <strong>:{{numero}}</strong></li>
            <li>Série: <strong>{{serie}}</strong></li>
            <li>Valor: <strong>{{valor}}</strong></li>
            <li>Chave de Acesso: <strong>{{chave}}</strong></li>
            </ul>
            <p>Qualquer dúvida estamos à disposição.</p>
            <p>Atenciosamente,</p>
            <p><strong>{{emitente_nome}}</strong></p>`,
  },
  'MDF-e': {
    subject: 'Manifesto Eletrônico de Documento Fiscal',
    body: `<p>Olá <strong>{{destinatario_nome}}</strong>,</p>
            <p>Segue em anexo o seu Manifesto Eletrônico de Documento Fiscal.</p>
            <p><u>Detalhes do MDF-e:</u></p>
            <ul>
            <li>Número: <strong>:{{numero}}</strong></li>
            <li>Série: <strong>{{serie}}</strong></li>
            <li>Valor: <strong>{{valor}}</strong></li>
            <li>Chave de Acesso: <strong>{{chave}}</strong></li>
            </ul>
            <p>Qualquer dúvida estamos à disposição.</p>
            <p>Atenciosamente,</p>
            <p><strong>{{emitente_nome}}</strong></p>`,
  },
};

const EmailTemplateConfig: React.FC<EmailTemplateConfigProps> = observer(
  ({ title, store }) => {
    const quillRef = React.useRef<ReactQuill>(null);

    const handleTagClick = (tag: string) => {
      const quill = quillRef.current?.getEditor();
      if (quill) {
        const range = quill.getSelection(true);
        if (range) {
          quill.insertText(range.index, tag);
          quill.setSelection(range.index + tag.length, 0);
        }
      }
    };

    return (
      <Box>
        <HeaderBox>
          <span>Template {title}</span>
          <SwitchButton
            checked={store.enabled}
            onChange={(checked) => {
              store.setEnabled(checked);
              if (checked) {
                if (!store.subject || !store.subject.trim()) {
                  store.setSubject(defaultTemplates[title]?.subject || '');
                }
                if (
                  !store.body ||
                  !store.body.trim() ||
                  store.body === '<p><br></p>'
                ) {
                  store.setBody(defaultTemplates[title]?.body || '');
                }
                store.setAttachXml(true);
                store.setAttachPdf(true);
              }
            }}
          />
        </HeaderBox>
        {store.enabled && (
          <Box>
            <Row>
              <Field style={{ flex: 1 }}>
                Assunto
                <Input
                  value={store.subject}
                  onChange={(e) => store.setSubject(e.target.value)}
                />
              </Field>
            </Row>
            <Row>
              <Field style={{ flex: 1 }}>
                E-mail para Resposta (Opcional)
                <Input
                  value={store.replyTo}
                  onChange={(e) => store.setReplyTo(e.target.value)}
                />
              </Field>
              <Field style={{ flex: 1 }}>
                E-mail para cópia (Opcional)
                <Input
                  value={store.cc}
                  onChange={(e) => store.setCc(e.target.value)}
                />
              </Field>
            </Row>
            <Row
              style={{
                marginLeft: '5px',
                marginTop: '10px',
                alignItems: 'center',
              }}
            >
              <label
                style={{
                  flexDirection: 'row',
                  cursor: 'pointer',
                  fontSize: '14px',
                }}
              >
                <input
                  type="checkbox"
                  checked={store.attachXml}
                  onChange={(e) => store.setAttachXml(e.target.checked)}
                  style={{ marginRight: '8px' }}
                />
                Enviar XML em anexo
              </label>
              <label
                style={{
                  flexDirection: 'row',
                  cursor: 'pointer',
                  fontSize: '14px',
                  marginRight: '5px',
                }}
              >
                <input
                  type="checkbox"
                  checked={store.attachPdf}
                  onChange={(e) => store.setAttachPdf(e.target.checked)}
                  style={{ marginRight: '8px' }}
                />
                Enviar PDF em anexo
              </label>
            </Row>
            <QuillWrapper>
              <Field>
                Mensagem
                <ReactQuill
                  ref={quillRef}
                  theme="snow"
                  value={store.body}
                  onChange={(content) => store.setBody(content)}
                />
              </Field>
            </QuillWrapper>
            <TagList>
              Tags:{' '}
              <span onClick={() => handleTagClick('{{numero}}')}>
                {'{{numero}}'}
              </span>{' '}
              <span onClick={() => handleTagClick('{{serie}}')}>
                {'{{serie}}'}
              </span>{' '}
              <span onClick={() => handleTagClick('{{valor}}')}>
                {'{{valor}}'}
              </span>{' '}
              <span onClick={() => handleTagClick('{{destinatario_nome}}')}>
                {'{{destinatario_nome}}'}
              </span>{' '}
              <span onClick={() => handleTagClick('{{emitente_nome}}')}>
                {'{{emitente_nome}}'}
              </span>{' '}
              <span onClick={() => handleTagClick('{{chave}}')}>
                {'{{chave}}'}
              </span>
            </TagList>

            {title !== 'MDF-e' && (
              <label
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  marginLeft: '5px',
                }}
              >
                Envio automático
                <SwitchButton
                  checked={store.autoSend}
                  onChange={(checked) => store.setAutoSend(checked)}
                />
              </label>
            )}
          </Box>
        )}
      </Box>
    );
  }
);

const Settings: React.FC = observer(() => {
  const params = useParams();
  const { isMigrating } = useSession();
  const { api } = new ApiService(params?.token);
  const [draft] = React.useState(() => new ConfigStore());

  async function loadSettings() {
    try {
      await draft.load(api);
    } catch (error: any) {
      if (error?.response?.status !== 401 && error?.response?.status !== 403) {
        toast.error('Erro ao carregar configurações');
      }
    }
  }

  useEffect(() => {
    if (!isMigrating) {
      loadSettings();
    }
  }, [isMigrating]);

  async function handleSubmit(e: any) {
    e.preventDefault();

    try {
      draft.setLoading(true);
      const formData = new FormData();

      if (draft.nfe?.uploadCertificado?.file) {
        formData.append(
          'file_nfe_certificado',
          draft.nfe.uploadCertificado.file
        );
      }
      formData.append('data', JSON.stringify(draft.toJSON()));
      const response = await api.put('/settings', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      draft.loadFromBackend(response.data);
      data.loadFromBackend(response.data); // Sincroniza com o Store Global!
      toast.success('Configurações salvas com sucesso');
    } catch (error: any) {
      draft.nfe.setUploadCertificado(undefined, '');
      draft.nfe.setRemoverCertificado(undefined);
      console.log(error?.response?.data);
      if (error?.response?.data?.errors) {
        error?.response?.data?.errors.forEach((err: any) => {
          toast.error(err);
        });
      } else {
        toast.error(
          error?.response?.data?.error || 'Falha ao salvar as configurações'
        );
      }
    } finally {
      draft.setLoading(false);
    }
  }

  async function handleTestEmail() {
    // eslint-disable-next-line no-alert
    const emailDest = window.prompt('Digite o e-mail de destino para o teste:');
    if (!emailDest) return;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(emailDest.trim())) {
      toast.error('Informe um e-mail de destino válido.');
      return;
    }

    try {
      draft.setLoading(true);
      await api.post('/settings/email/test', {
        email: emailDest.trim(),
        smtp: {
          host: draft.email.smtp.host,
          port: Number(draft.email.smtp.port),
          secure: draft.email.smtp.secure,
          user: draft.email.smtp.user,
          pass: draft.email.smtp.pass,
        },
      });
      toast.success('E-mail de teste enviado com sucesso!');
    } catch (error: any) {
      toast.error(
        error?.response?.data?.error || 'Falha ao enviar e-mail de teste'
      );
    } finally {
      draft.setLoading(false);
    }
  }

  if (draft.loading) {
    return <Loading />;
  }

  if (!draft.authenticated) {
    return <NotAuthenticated />;
  }

  return (
    <Container>
      <Title>CONFIGURAÇÕES</Title>

      <Form onSubmit={handleSubmit}>
        <ApplyButton>
          <MdDone size={24} />
          APLICAR
        </ApplyButton>
        <SectionTitle>Documentos Eletrônicos</SectionTitle>
        <Box>
          <HeaderBox>
            <span>NF-e</span>
            <SwitchButton
              checked={draft.nfe.enabled}
              onChange={(checked) => draft.nfe.setEnabled(checked)}
            />
          </HeaderBox>
          {draft.nfe.enabled && (
            <Box>
              <Field>
                Ambiente
                <SelectInput
                  fullWidth
                  options={ambienteOptions}
                  value={ambienteOptions.find(
                    (opt) => opt.value === draft.nfe.ambiente
                  )}
                  onChange={(newValue: any) =>
                    draft.nfe.setAmbiente(newValue.value)
                  }
                />
              </Field>
            </Box>
          )}
        </Box>
        <Box>
          <HeaderBox>
            <span>NFC-e</span>
            <SwitchButton
              checked={draft.nfce.enabled}
              onChange={(checked) => draft.nfce.setEnabled(checked)}
            />
          </HeaderBox>
          {draft.nfce.enabled && (
            <Box>
              <Field>
                Ambiente
                <SelectInput
                  fullWidth
                  options={ambienteOptions}
                  value={ambienteOptions.find(
                    (opt) => opt.value === draft.nfce.ambiente
                  )}
                  onChange={(newValue: any) =>
                    draft.nfce.setAmbiente(newValue.value)
                  }
                />
              </Field>
            </Box>
          )}
        </Box>
        <Box>
          <HeaderBox>
            <span>NFS-e</span>
            <SwitchButton
              checked={draft.nfse.enabled}
              onChange={(checked) => draft.nfse.setEnabled(checked)}
            />
          </HeaderBox>
          {draft.nfse.enabled && (
            <Box>
              <Field>
                Ambiente
                <SelectInput
                  fullWidth
                  options={ambienteOptions}
                  value={ambienteOptions.find(
                    (opt) => opt.value === draft.nfse.ambiente
                  )}
                  onChange={(newValue: any) =>
                    draft.nfse.setAmbiente(newValue.value)
                  }
                />
              </Field>
            </Box>
          )}
        </Box>
        <Box>
          <HeaderBox>
            <span>CT-e</span>
            <SwitchButton
              checked={draft.cte.enabled}
              onChange={(checked) => draft.cte.setEnabled(checked)}
            />
          </HeaderBox>
          {draft.cte.enabled && (
            <Box>
              <Field>
                Ambiente
                <SelectInput
                  fullWidth
                  options={ambienteOptions}
                  value={ambienteOptions.find(
                    (opt) => opt.value === draft.cte.ambiente
                  )}
                  onChange={(newValue: any) =>
                    draft.cte.setAmbiente(newValue.value)
                  }
                />
              </Field>
            </Box>
          )}
        </Box>
        <Box>
          <HeaderBox>
            <span>MDF-e</span>
            <SwitchButton
              checked={draft.mdfe.enabled}
              onChange={(checked) => draft.mdfe.setEnabled(checked)}
            />
          </HeaderBox>
          {draft.mdfe.enabled && (
            <Box>
              <Field>
                Ambiente
                <SelectInput
                  fullWidth
                  options={ambienteOptions}
                  value={ambienteOptions.find(
                    (opt) => opt.value === draft.mdfe.ambiente
                  )}
                  onChange={(newValue: any) =>
                    draft.mdfe.setAmbiente(newValue.value)
                  }
                />
              </Field>
            </Box>
          )}
        </Box>

        <SectionTitle>Certificado Digital</SectionTitle>
        <Box>
          <HeaderBox>
            <span>Certificado Digital</span>
          </HeaderBox>
          <Certificate
            certificate={draft.nfe.certificado}
            enabled={
              draft.nfe.enabled ||
              draft.nfce.enabled ||
              draft.nfse.enabled ||
              draft.cte.enabled ||
              draft.mdfe.enabled
            }
            onChange={(file: File, password: string) => {
              draft.nfe.setUploadCertificado(file, password);
            }}
            onRemove={() => {
              draft.nfe.setRemoverCertificado(true);
            }}
          />
        </Box>

        <SectionTitle>Configurações de E-mail</SectionTitle>

        <Box>
          <HeaderBox>
            <span>SMTP</span>
          </HeaderBox>
          <Box>
            <Field>
              Host
              <Input
                value={draft.email.smtp.host}
                onChange={(e) => draft.email.setSmtp('host', e.target.value)}
                placeholder="smtp.exemplo.com"
              />
            </Field>
            <Row>
              <Field style={{ flex: 1 }}>
                Porta
                <Input
                  type="number"
                  value={draft.email.smtp?.port || ''}
                  onChange={(e) =>
                    draft.email.setSmtp('port', Number(e.target.value))
                  }
                />
              </Field>
              <Field style={{ flex: 1 }}>
                Usuário
                <Input
                  value={draft.email.smtp.user}
                  onChange={(e) => draft.email.setSmtp('user', e.target.value)}
                />
              </Field>
              <Field style={{ flex: 1 }}>
                Senha
                <Input
                  type="password"
                  value={draft.email.smtp.pass}
                  onChange={(e) => draft.email.setSmtp('pass', e.target.value)}
                />
              </Field>
            </Row>
            <Field
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
              }}
            >
              Usar SSL/TLS (Porta 465)
              <SwitchButton
                checked={draft.email.smtp.secure}
                onChange={(checked) => draft.email.setSmtp('secure', checked)}
              />
            </Field>
            <Field style={{ width: '200px' }}>
              Limite de envios (por hora)*
              <Input
                type="number"
                placeholder="Ilimitado"
                value={draft.email.limitPerHour || ''}
                onChange={(e) => {
                  const val = e.target.value;
                  draft.email.setLimitPerHour(val ? Number(val) : undefined);
                }}
              />
            </Field>
            <p>
              *Recomenda-se a utilização de um servidor SMTP dedicado para o
              envio de e-mails
              <b> transacionais</b>, os quais geralmente não possuem restrições
              de volume.
            </p>
            <p>
              Caso opte por um SMTP convencional e possua uma alta demanda de
              e-mails, é aconselhável estipular um limite de envios por hora
              para mitigar o risco de bloqueios.
            </p>
            <Row style={{ marginTop: '15px', justifyContent: 'flex-start' }}>
              <Button type="button" onClick={handleTestEmail}>
                Testar Envio de E-mail
              </Button>
            </Row>
          </Box>
        </Box>

        {draft.nfe.enabled && (
          <EmailTemplateConfig title="NF-e" store={draft.email.templates.nfe} />
        )}
        {draft.nfce.enabled && (
          <EmailTemplateConfig
            title="NFC-e"
            store={draft.email.templates.nfce}
          />
        )}
        {draft.nfse.enabled && (
          <EmailTemplateConfig
            title="NFS-e"
            store={draft.email.templates.nfse}
          />
        )}
        {draft.cte.enabled && (
          <EmailTemplateConfig title="CT-e" store={draft.email.templates.cte} />
        )}
        {draft.mdfe.enabled && (
          <EmailTemplateConfig
            title="MDF-e"
            store={draft.email.templates.mdfe}
          />
        )}
        <ApplyButton style={{ marginTop: 20 }}>
          <MdDone size={24} />
          APLICAR
        </ApplyButton>
      </Form>
    </Container>
  );
});

export default Settings;
